export const BLOCKED_MODELS = ['fofr/video-to-frames'];

export const SERVICE_TO_PROVIDER_ID = {
  fal_imported: 'fal',
  civit: 'civit',
  replicate: 'replicate',
} as const;

export type ImportableModelService = keyof typeof SERVICE_TO_PROVIDER_ID;

export const PROVIDER_ID_TO_SERVICE = Object.fromEntries(
  Object.entries(SERVICE_TO_PROVIDER_ID).map(([service, providerId]) => [providerId, service]),
) as Record<string, ImportableModelService>;

export enum ModelProviderIdentifier {
  Civitai = '/civitai.com',
  FalDomain = '/fal.ai',
  FalPrefix = 'fal-ai',
  Replicate = 'https://replicate.com/',
}
